import { c as _c } from "react/compiler-runtime";
import { InlineAlert } from '@onefootprint/ui';
import { Trans } from 'react-i18next';
type NewPrerequisitesAlertProps = {
  /** Prerequisite ids required by the versions serving traffic today. */
  deployed: string[];
  /** Prerequisite ids the deployment being created will require. */
  pending: string[];
};

/**
 * Warns when the pending deployment requires prerequisite data that no currently-deployed version
 * does. That's a breaking change: integrations that aren't already sending the field start failing
 * the moment the deployment lands.
 */
const NewPrerequisitesAlert = t0 => {
  const $ = _c(12);
  const {
    deployed,
    pending
  } = t0;
  let t1;
  if ($[0] !== deployed || $[1] !== pending) {
    let t2;
    if ($[3] !== deployed) {
      t2 = id => !deployed.includes(id);
      $[3] = deployed;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    t1 = new Set(pending.filter(t2));
    $[0] = deployed;
    $[1] = pending;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[5] !== t1) {
    t2 = [...t1];
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const fields = t2;
  if (fields.length === 0) {
    return null;
  }
  const t3 = fields.join(", ");
  let t4;
  if ($[7] !== t3) {
    t4 = {
      fields: t3
    };
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      emphasis: <em className="italic" />
    };
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t4) {
    t6 = <InlineAlert variant="error"><Trans ns="playbook-builder" i18nKey={_temp} values={t4} components={t5} /></InlineAlert>;
    $[10] = t4;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
};
export default NewPrerequisitesAlert;
function _temp($) {
  return $.deployment.form.newPrerequisites;
}